/* Copyright 2022- Martin Kufner */
import "@qb-gettext-js/gettext";
import { DateTime } from "@node/luxon";
export class Strftime {

    // Date
    // %Y - Year including century, zero-padded:
    // %y - Year without century, in range (0.99), zero-padded:
    // %C - Century, zero-padded:
    // %m - Month of the year, in range (1..12), zero-padded:
    // %B - Full month name, capitalized:
    // %b - Abbreviated month name, capitalized:
    // %h - Same as %b.
    // %d - Day of the month, in range (1..31), zero-padded:
    // %e - Day of the month, in range (1..31), blank-padded:
    // %j - Day of the year, in range (1..366), zero-padded:

    // Weekday
    // %A - Full weekday name:
    // %a - Abbreviated weekday name:
    // %u - Day of the week, in range (1..7), Monday is 1
    // %w - Day of the week, in range (0..6), Sunday is 0

    // Week number
    // %U - Week number of the year, in range (0..53), zero-padded, where each week begins on a Sunday:
    // %W - Week number of the year, in range (0..53), zero-padded, where each week begins on a Monday:

    // Week Dates
    // %G - Week-based year
    // %g - Week-based year without century, in range (0..99), zero-padded:
    // %V - Week number of the week-based year, in range (1..53), zero-padded:

    // Time
    // %H - Hour of the day, in range (0..23), zero-padded:
    // %k - Hour of the day, in range (0..23), blank-padded:
    // %I - Hour of the day, in range (1..12), zero-padded:
    // %l - Hour of the day, in range (1..12), blank-padded:
    // %P - Meridian indicator, lowercase:
    // %p - Meridian indicator, uppercase:
    // %M - Minute of the hour, in range (0..59), zero-padded:
    // %S - Second of the minute in range (0..59), zero-padded:
    // %L - Millisecond of the second, in range (0..999), zero-padded:
    // * %N - Fractional seconds, default width is 9 digits (nanoseconds):
    // %s - Number of seconds since the epoch:

    // Time zone
    // %z - Timezone as hour and minute offset from UTC:
    // %Z - Timezone name (platform-dependent):
    // Timezone Flags
    // : - Put timezone as colon-separated hours and minutes: => "-05:00"
    // :: - Put timezone as colon-separated hours, minutes, and seconds:

    // Shorthand Conversion Specifiers
    // %c - Date and time  '%a %b %e %T %Y'  # => "Wed Jun 29 08:01:41 2022"
    // %D | %x - Date: '%m/%d/%y' # => "06/29/22"
    // %F - ISO 8601 date: '%Y-%m-%d' # => "2022-06-29"
    // %v - VMS date: '%e-%^b-%4Y' # => "29-JUN-2022"
    // %r - 12-hour time '%I:%M:%S %p'  # => "01:00:00 AM"
    // %R - 24-hour tine '%H:%M' # => "13:00"
    // %T | %X - 24-hour time w/ seconds '%H:%M:%S' # => "13:00:00"
    // %+ not supported

    static shorthand(format) {
        format = format.replace(/%c|%D|%x|%F|%v|%r|%R|%T|%X/g, m => {
            switch(m) {
                case "%c":
                    return '%a %b %e %T %Y';
                case "%D":
                case "%x":
                    return '%m/%d/%y';
                case "%F":
                    return '%Y-%m-%d';
                case "%v":
                    return '%e-%^b-%Y';
                case "%r":
                    return '%I:%M:%S %p';
                case "%R":
                    return '%H:%M';
                case "%T":
                case "%X":
                    return '%H:%M:%S';
//                 case "%+":
//                     debugger;
//                     return `${this.#date}
// Year: %%Y %Y %%y %y %%C %C
// Month: %%m %m %%-m %-m %%B %B %%^B %^B %%b %b %%^b %^b
// Day: %%d %d %%-d %-d %%e %e %%j %j %%A %A %%a %a %%u %u %%w %w
// Hour: %%H %h %%k %k %%I %I %%l %l %%P %P %%p %p
// Minute/Second/usec: %%M %M %%S %S %%s %s %%L %L %%N %N
// Zone: %%z %z %%:z %:z %%Z %Z
//                     `;
            }
        });
        if(/%[cDxFvrRTX]/.test(format)) return this.shorthand(format);
        return format;
    };

    static re = /(?:(%)([\?><])?([0_$^:\-])?([AaBbCdeGghHIjklLmMNPpSsuUVwWYyzZ]))|(%[nt])|(%%|[^%]+)/g

    parts = [];
    #date

    constructor(...args) {
        this.format = args.find(arg => typeof arg === 'string') || "%c";
        this.date = args.find(arg => arg instanceof Date);
    }

    

    get format() { return this._format }

    set format(format) {
        this._format = this.constructor.shorthand(format);
        const matches = [...this._format.matchAll(this.constructor.re)];
        matches.forEach(([match, isFormat, type, flag, format, sep], i) => {
            if(isFormat) switch(format) {
                case "N":
                    return; // ignore
                case "h":
                    format = "b";
                default:
                    this.method(format, flag, type);
            }
            else if(sep === "%n") this.parts.push("\n");
            else if(sep === "%t") this.parts.push("\t");
            else this.text(match);
        });
    }

    method(format, flag, type) {
        switch(flag) {
            case "$":
                format = `$${format}`;
                break;
            case ":":
            case "^":
                format = flag + format;
                break;
            case "0":
            case "-":
            case "_":
        }
        let places = 1, pad = '0';
        if(/[YGg]/.test(format)) places = 4;
        else if(/[jL]/.test(format)) places = 3;
        else if(/[yCmdIMSUWVHI]/.test(format)) places = 2;
        else if(/[ekl]/.test(format)) {
            places = 2;
            pad = " ";
        }
        else pad = undefined;

        format = '%' + format;
        if(!this[format]) return;
        this.parts.push(Object.assign(this[format].bind(this), {format, flag, type, pad, places}));
    }

    get last() { return this.parts[this.parts.length - 1] }

    text(text) {
        const last = this.last;
        if(typeof last === "string" && !/^[\n\t]$/.test(last)) this.parts[this.parts.length - 1] += text;
        else this.parts.push(text);
    }


    set date(date) {
        if(!date) return;
        this.#date = DateTime.fromJSDate(date, { zone: date.zone}).setLocale(date.lang || document.lang);
    }
    

    get date() { return this.#date }
    get zone() { return this.#date.zoneName; }

    values(date) {
        if(date) this.date = date;
        if(!this.date.isValid) return [];
        return this.parts.filter(p => p).map(part => typeof part === "string" ? part : part())
    }

    toString(date) { return this.values(date).join(""); }



    get hour() { return this.#date.hour }
    get minute() { return this.#date.minute }
    get second() { return this.#date.second }
    

    ['%$H']() { return self.n_("1 Hour", "%{hours} Hours", this.hour, { hours:  this.hour}); }
    ['%$M']() { return self.n_("1 Minute", "%{minutes} Minutes", this.minute, { minutes:  this.minute}) }
    ['%$S']() { return self.n_("1 Second", "%{seconds} Seconds", this.second, { seconds:  this.second}) }


    //Year including century, zero-padded:
    ['%Y']() { return this.#date.toFormat('yyyy'); }

    //Year without century, in range (0.99), zero-padded:
    ['%y']() { return this.#date.toFormat('yyyy').slice(2) }

    //Century, zero-padded:
    ['%C']() { return this.#date.toFormat('yyyy').slice(0,2) }

    //Month of the year, in range (1..12), zero-padded:
    ['%m']() { return this.#date.toFormat('LL') }
    ['%-m']() { return this.#date.month }

    // Full month name & capitalized:
    ['%B']() { return this.#date.toFormat('LLLL'); }
    ['%^B']() { return this['%B']()?.toUpperCase(); }

    // Abbreviated month name & capitalized:
    ['%b']() { return this.#date.toFormat('LLL'); }
    ['%^b']() { return this['%b']()?.toUpperCase(); }

    //Day of the month, in range (1..31), zero-padded:
    ['%d']() { return this.#date.toFormat('dd'); }
    ['%-d']() { return this.#date.day }

    //Day of the month, in range (1..31), blank-padded:
    ['%e']() { return this['%d']().replace(/^0/, " "); }


    ['%j']() { return this.#date.toFormat('ooo') }

    // Weekday

    //Full weekday name:
    ['%A']() { return this.#date.toFormat('cccc'); }

    //Abbreviated weekday name:
    ['%a']() { return this.#date.toFormat('ccc'); }

    //Day of the week, in range (1..7), Monday is 1
    ['%u']() { this.#date.weekday }

    //Day of the week, in range (0..6), Sunday is 0
    ['%w']() { throw '%w not implemented' }


    //Week number of the year, in range (0..53), zero-padded, where each week begins on a Sunday:
    ['%U']() { throw '%u not implemented' }

    //Week number of the year, in range (01..53), zero-padded, where each week begins on a Monday:
    ['%W']() { return this.#date.toFormat('WW'); }

    // Week Dates

    //Week-based year
    ['%G']() { return this.#date.toFormat('kkkk'); }

    //Week-based year without century, in range (0..99), zero-padded:
    ['%g']() { throw '%g not implemented' }

    //Week number of the week-based year, in range (1..53), zero-padded:
    ['%V']() { throw '%V not implemented' }

    // Time

    //Hour of the day, in range (0..23), zero-padded:
    ['%H']() { return this.#date.toFormat('HH'); }

    //Hour of the day, in range (0..23), blank-padded:
    ['%k']() { return this['%H'].replace(/^0/, " "); }

    //Hour of the day, in range (1..12), zero-padded:
    ['%I']() { return this.#date.toFormat('HH'); }

    //Hour of the day, in range (1..12), blank-padded:
    ['%l']() { return this['%I']().replace(/^0/, " "); }

    //Meridian indicator, lowercase:
    ['%P']() { return this.#date.toFormat('mm'); }

    //Meridian indicator, uppercase:
    ['%p']() { return this['%P']()?.toUpperCase(); }

    //Minute of the hour, in range (0..59), zero-padded:
    ['%M']() { return this.#date.toFormat('mm'); }

    //Second of the minute in range (0..59), zero-padded:
    ['%S']() { return this.#date.toFormat('ss'); }


    //Millisecond of the second, in range (0..999), zero-padded:
    ['%L']() { return this.#date.toFormat('SSS'); }

    ['%N']() { return `${this['%P']()}000`; }

    //Number of seconds since the epoch:
    ['%s']() { return Math.floor(this.#date.toSeconds()); }
    

    //Timezone as hour and minute offset from UTC:
    ['%z']() { return this['%:z']().replace(/:/, ""); }

    //Timezone as hour and minute offset from UTC:
    ['%:z']() { return this.#date.toFormat('ZZ') }

    //Timezone name (platform-dependent):
    ['%Z']() { return this.#date.offsetNameShort; }
    ['%^Z']() { return this.zone }
}

const instance_properties = {
    strftime_object: {
        value(format_string) { return new Strftime(this, format_string); }
    },

    strftime: {
        value(format_string) { return new Strftime(format_string, this).toString(); }
    }


    // : - Put timezone as colon-separated hours and minutes: => "-05:00"
    // :: - Put timezone as colon-separated hours, minutes, and seconds:
};

Date.Strftime = Strftime;
Object.defineProperties(Date.prototype, instance_properties);

